<homey-page-title-layout>Common Questions</homey-page-title-layout>
<p-accordion class="mt-4 mb-6">
  @for (faq of faqs; let i = $index; track faq.answer) {
    <p-accordion-panel value="{{ i }}">
      <p-accordion-header>
          <span>
            {{ faq.question }}
          </span>
      </p-accordion-header>
      <p-accordion-content>
        <p class="m-0" [innerHTML]="faq.answer"></p>
      </p-accordion-content>
    </p-accordion-panel>
  }
</p-accordion>
<div class="mt-auto flex flex-row justify-center">
  <homey-signup-button  signupText="Check elegibility" severity="secondary"/>
</div>
